// extracted by mini-css-extract-plugin
export var columnList = "_gr-0";